import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import About from "@/components/About";
import Treatments from "@/components/Treatments";
import HowItWorks from "@/components/HowItWorks";
import Faq from "@/components/Faq";
import Insurances from "@/components/Insurances";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page" className="bg-bone text-pine font-sans">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Treatments />
        <HowItWorks />
        <Insurances />
        <Faq />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
